import classNames from 'classnames';
import { CustomSwitchProps } from '../../../interfaces';
import '../../../styles.scss';
import { SwitchWrapper } from './styles';
import './styles.scss';

const CustomSwitcher: React.FC<CustomSwitchProps> = props => {
  const { className, checked, value, primary = true, ...rest } = props;

  return (
    <SwitchWrapper
      {...rest}
      className={classNames(className, { primary }, 'custom-switch')}
      checked={className?.includes('controlledInput') ? value : checked}
    />
  );
};

export default CustomSwitcher;
